export enum WebProtocols {
  STANDARD = 'STANDARD',
  SECURED = 'SECURED',
}
